module.exports = __webpack_public_path__ + "img/password.8b23335a.svg";